import loginController from '@/scripts/libs/login/controller';
import viddsee from '@/scripts/viddsee';
import webcall from '@/scripts/webcall';
import socialSharer from '@/scripts/libs/social-sharer';

const _video = {
  id: '',
};

const intTel = {
  $form: null,
  $input: null,
};

const _bindUIActions = function _bindUIActions() {
  $('.video__object__actions').on('click', '.action-bar__login__btn', (e) => {
    e.preventDefault();
    $(e.currentTarget).trigger('vs:ui:video:action_bar:share:toggle', true);
    $(e.currentTarget).trigger('vs:ui:video:action_bar:embed:toggle', true);

    viddsee.ui.modal.register.open({
      loginReason: e.currentTarget.dataset.loginReason,
    });
  });

  // Action Bar - Heart
  $('.video__object__actions').on('vs:app:video:action_bar:heart', (e, callback) => {
    let increment = false;
    const counter = $('.video__object__actions__heart a');
    let totalHearts = $('.video__object__actions__heart a').data('total-hearts');
    const videoTitle = $('.video__object__actions__heart a').data('video-title');

    if (counter.hasClass('selected')) {
      increment = false;
      totalHearts -= 1;
      ga('send', 'event', 'video', 'unlike', videoTitle);
    } else {
      increment = true;
      totalHearts += 1;
      ga('send', 'event', 'video', 'like', videoTitle);
      // Intercom('trackEvent', 'video-like')
    }

    $('.video__object__actions__heart a').data('total-hearts', totalHearts);
    let value = totalHearts;
    if (totalHearts > 1000) {
      value = totalHearts / 1000.0;
      value = value.toFixed(1);
      value = value + 'k';
    }
    counter.children('span').html('<span class="md-heart"></span> ' + value);

    const options = {};
    options.rating_id = 'rating_like';
    options.video_id = _video.id;
    options.params = {};
    options.params['rating_like'] = (increment) ? 1 : 0;
    webcall.postUserVideoRating(options, () => {
      $(e.target).trigger('vs:ui:video:action_bar:heart:toggle', increment);
    });
  });

  // FIXME: Form element is removed by intl-tel-input plugin during initialisation
  $('.download-app__content__sms__submit').on('click', (e) => {
    let phone = intTel.$input.intlTelInput('getNumber');
    // TODO: intlTelInput doesn't seems to work
    //       This is a workaround to get phone number without intlTelInput
    if (!phone) {
      const countryCode = intTel.$input.intlTelInput('getSelectedCountryData').dialCode;
      const phoneNumber = intTel.$input.val();
      phone = '+' + countryCode + phoneNumber;
    }

    const linkData = {
      tags: [],
      channel: 'Website',
      feature: 'Download from desktop',
      data: {
        $desktop_url: 'https://www.viddsee.com',
      },
    };
    const options = {};
    const callback = function callback(err, result) {
      if (err) {
        $('.download-app__content__sms__message')
          .removeClass('hidden')
          .text(I18n.t('javascript.video.action.download.message.sorry_something_went_wrong'));
      } else {
        $('.download-app__content__sms__message')
          .removeClass('hidden')
          .text(I18n.t('javascript.video.action.download.message.sms_has_been_sent'));
      }
    };
    e.preventDefault();

    if (_video.id && _video.id !== '') {
      linkData.data['$deeplink_path'] = 'video/' + _video.id;
    }

    branch.sendSMS(phone, linkData, options, callback);
  });

  // Action Bar - Share
  $('.video__object__actions').on('vs:app:video:action_bar:share', (e) => {
    $('.video__object__player').trigger('vs:ui:video:player:pause', true);

    const $target = $(e.target);

    // TODO: This is a hotfix for adapting itself to social-sharer.
    //       Ideally, social-sharer should just accept parameters and process accordingly.
    //       Perhaps it doesn't need to rely on HTML data text? Maybe is it just a different way of doing stuff.
    //       Let's discuss this in the future when this is revisited.
    e.currentTarget = e.target;
    switch ($target.data('type')) {
      case 'facebook':
        socialSharer.shareFB(e);
        break;
      case 'twitter':
        socialSharer.shareTW(e);
        break;
      case 'email':
        socialSharer.shareEmail(e);
        break;
      default: break;
    }

    $target.trigger('vs:ui:video:action_bar:share:toggle');
  });

  // Action Bar - Embed
  $('.video__object__actions').on('vs:app:video:action_bar:embed', (e) => {
    const embedCode = '<iframe width="560" height="315" src="https://www.viddsee.com/player/' + _video.id + '" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>';
    $(e.target)
      .parents('.video__object__actions__embed')
      .find('.video__object__actions__embed-link')
      .val(embedCode);
    if (typeof fbq === 'function') {
      fbq('trackCustom', 'Share');
    }

    const title = $('.js-video__embed').data('video-title');
    ga('send', 'event', 'social-media', 'embed', title);
  });
};

const _initPageData = function _initPageData() {
  // Sets the page's video id.
  _video.id = $('.video').attr('data-video-uid');
};

const _initHearts = function _initHearts() {
  webcall.getUserVideoRating({
    video_id: _video.id,
  }, (res) => {
    if (res.rating_like > 0) {
      $('.video__object__actions__heart a').addClass('selected');
    }
  });
};

const _initVideoDownload = function _initVideoDownload() {
  // FIXME: Refactor this to remove hard linking to overlay
  $('.js-video__download').click(function showDownloadVideo(e) {
    e.preventDefault();
    if ($(window).width() <= 544) {
      $('.video__object__player__overlay--download').toggleClass('hidden');
      $('.video__object__player__overlay--download .btn-close').click(function closeDownloadVideo() {
        $(this)
          .parent()
          .addClass('hidden');
      });
    } else {
      $(this)
        .siblings('.video__object__actions__tooltip--download')
        .toggleClass('hidden');
    }
  });

  $('.js-video__download__text').click((e) => {
    e.preventDefault();
    $(e.currentTarget)
      .parent()
      .siblings('.video__object__actions__tooltip--download__text-app')
      .removeClass('hidden');
  });

  return this;
};

const _initIntlTelInput = function _initIntlTelInput() {
  intTel.$form = $('.download-app__form');
  intTel.$input = intTel.$form.find('input');
  intTel.$input.intlTelInput({
    initialCountry: 'auto',
    preferredCountries: ['sg'],
    geoIpLookup(callback) {
      $.get('/ip_json').always(({ country_code: countryCode }) => {
        callback(countryCode || 'SG');
      });
    },
  });

  return this;
};

const ActionBar = {
  init() {
    _initPageData();
    _initIntlTelInput();
    _bindUIActions();
    _initVideoDownload();

    // FIXME: You know you should clean this up right?
    // Trigger UI updates if the user is or NOT logged in
    loginController.checkLoginStatus((status) => {
      if (status === 'signed_in') {
        // Replace class for heart
        $('.video__object__actions__heart a')
          .removeClass('action-bar__login__btn')
          .addClass('js-video__heart');
        $('.video__object__actions__add-to-playlist a')
          .removeClass('action-bar__login__btn');

        _initHearts();
      }
    });
  },
};

export default ActionBar;
